// this file gets replaced with the real value during the build
export default '6.10.1' as string;
